import React, { useEffect, useState } from 'react';

const useDetectClick = (className:string, callBack:(clicked:boolean) => void, containsOnly?:boolean) => {

    // Detect if user has clicked a specific class in the tree with event bubbling

    useEffect(() => {
            
        function clickListener(e:any){
            if (inTree(e)){
                callBack(true)
            }
            else {
                callBack(false)
            }
        }

        function inTree(e:any):boolean{

            const path = e.path || (e.composedPath && e.composedPath());
    
            if (path){
                for (const p of path){ 
                    
                    // Find only this classname
                    if (containsOnly){
                        
                        if (typeof p.className === 'string'){
                            if (Array.isArray(p.className.split(' ')) && p.className.split(' ').find((x: string) => x === className)){
                                return true
                            }
                        }
                    }
                    else if (p.className === className){
                        return true;
                    }  
                }
            }
    
            return false;
        }

        window.addEventListener('click', clickListener); 

        return () => { window.removeEventListener('click', clickListener);}

    }, [className])

};


export const useDetectClickAsync = (className:string) => {

    // Detect if user has clicked a specific class in the tree with event bubbling
    
    const [classClicked, setClassClicked] = useState<boolean>(false)

    useEffect(() => {
            
        function clickListener(e:any){

            if (inTree(e)){
                setClassClicked(true)
            }
            else {
                setClassClicked(false)
            }
        }

        function inTree(e:any):boolean{

            const path = e.path || (e.composedPath && e.composedPath());
    
            if (path){
                for (let i = 0; i < path.length; i++){  
                    if (path[i].className === className){
                        return true;
                    }  
                }
            }
    
            return false;
        }

        window.addEventListener('click', clickListener); 

        return () => { window.removeEventListener('click', clickListener); }

    }, [className])

    return classClicked

};

export default useDetectClick;